// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btTop {
  text-align: right;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.btTop > * {
  margin-left: 1rem;
}

.bloc-edit-group--stacked {
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
}

.field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.field--full {
  flex: 1 1 100%;
  width: 100%;
}

.field.has-error ::ng-deep .p-dropdown {
  border-color: #e24c4c;
}

.field--code input[pInputText] {
  width: 28rem;
  max-width: 100%;
}

.field--code input[pInputText].ng-invalid {
  border-color: #e24c4c;
}

.field--name input[pInputText] {
  width: 36rem;
  max-width: 100%;
}

.field--full textarea {
  width: 100%;
}

.campaigns-section {
  margin-top: 0.5rem;
}

.add-campaigns {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.add-campaigns p-multiSelect {
  min-width: 20rem;
}

.form-actions {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.read-placeholder {
  color: #666;
  font-style: italic;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/marketing/campaign-group/campaign-group-edit/campaign-group-edit.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EACI,iBAAA;AACR;;AAGA;EACI,sBAAA;EACA,iBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,cAAA;EACA,WAAA;AAAJ;;AAGA;EACI,qBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,eAAA;AAAJ;;AAGA;EACI,qBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,SAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;AACA,g4EAAg4E","sourcesContent":[".btTop {\n    text-align: right;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n\n    > * {\n        margin-left: 1rem;\n    }\n}\n\n.bloc-edit-group--stacked {\n    flex-direction: column;\n    flex-wrap: nowrap;\n    width: 100%;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.field--full {\n    flex: 1 1 100%;\n    width: 100%;\n}\n\n.field.has-error ::ng-deep .p-dropdown {\n    border-color: #e24c4c;\n}\n\n.field--code input[pInputText] {\n    width: 28rem;\n    max-width: 100%;\n}\n\n.field--code input[pInputText].ng-invalid {\n    border-color: #e24c4c;\n}\n\n.field--name input[pInputText] {\n    width: 36rem;\n    max-width: 100%;\n}\n\n.field--full textarea {\n    width: 100%;\n}\n\n.campaigns-section {\n    margin-top: 0.5rem;\n}\n\n.add-campaigns {\n    display: flex;\n    gap: 0.75rem;\n    align-items: center;\n    margin-bottom: 1rem;\n    flex-wrap: wrap;\n}\n\n.add-campaigns p-multiSelect {\n    min-width: 20rem;\n}\n\n.form-actions {\n    display: flex;\n    gap: 1rem;\n    margin-top: 0.5rem;\n}\n\n.read-placeholder {\n    color: #666;\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
